import script from "./text.vue?vue&type=script&lang=ts&setup=true"
export * from "./text.vue?vue&type=script&lang=ts&setup=true"

import "./text.vue?vue&type=style&index=0&id=13ddbe7a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_typescript@4.9.5__webpack@5.97.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13ddbe7a"]])

export default __exports__